import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  ContentTemplate,
  HeaderTemplate,
  Link,
  SectionHeader,
  TitleHeader,
} from 'web-library';
import MuiBreadCrumbs from 'web-library/stories/molecule/BreadCrumbs/MuiBreadCrumbs';
import { useMediaQuery } from '@mui/material';
import { Theme as AugmentedTheme, useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useHistory, useLocation } from 'react-router-dom';
import { CreateCandidateFormLocationState } from '../../modules/accountManagement/logic/useCreateCandidateForm';

const useStyles = makeStyles()((theme) =>
({
  root: {
    marginBottom: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(7),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      height: 'fit-content',
    },
  },
}));

const SuccessfulAccountCreationPage = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { state } = useLocation<CreateCandidateFormLocationState>();

  return (
    <>
      <HeaderTemplate>
        {!isMobile && (
          <Box className={classes.root}>
            <MuiBreadCrumbs separator="NextIcon">
              <Link href="/">{t('profile->>CreateCandidateForm.Login')}</Link>
              <>{t('profile->>CreateCandidateForm.Create Account')}</>
            </MuiBreadCrumbs>
          </Box>
        )}
      </HeaderTemplate>
      <TitleHeader
        state="success"
        title={t('profile->>SuccessfulAccountCreation.Account successfully created.')}
      />

      <ContentTemplate>
        <SectionHeader title={t('profile->>SuccessfulAccountCreation.Account Created')} />
        <>
          {state?.credentialType === 'SINGPASS'
            ? t('profile->>SuccessfulAccountCreation.MessageForSingpass')
            : t('profile->>SuccessfulAccountCreation.Message')}
        </>
        <br />
        <Button
          id="button-SuccessfulAccountCreation-backToLogin"
          onClick={() => history.push('/')}
          className={classes.button}
        >
          {t('profile->>SuccessfulAccountCreation.Back to Login')}
        </Button>
      </ContentTemplate>
    </>
  );
};

export default SuccessfulAccountCreationPage;
